import { getPortalId } from './getPortalId';
export const getRootUrl = () => {
  const portalId = getPortalId() || '';
  return `/notifications/${portalId}`;
};
export const getHublessRootUrl = () => {
  return '/notifications/hubless';
};